import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {InicioFaces} from '../interfaces/inicioFaces';
import {HttpParams} from  "@angular/common/http";
import {environment} from "../../environments/environment";
import Constants from "../lib/Constants";

@Injectable({
    providedIn: 'root'
})
export class InicioService {

    public httpOptions = {
        headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*'
        })
    };

API_ENDPOINT: string = Constants.BASEURLAPI + '/api';





    constructor(private httpClient: HttpClient) {
    }

        static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {

    let config = {
        'required': 'Este campo es requerido'
    };

    return config[validatorName];
  }

    //consultar tmr Colombia
    public tmrColombiaService() {
        return this.httpClient.get(this.API_ENDPOINT + '/tmrColombia', this.httpOptions);
    }

    public listarExtenciones() {
       return this.httpClient.get(this.API_ENDPOINT + '/listarExtensiones', this.httpOptions);
    }
    public mostrarEnlacesExternos() {
        return this.httpClient.get(this.API_ENDPOINT + '/mostrarEnlacesExternos', this.httpOptions);
    }
    public mostrarEnlacesLocales() {
        return this.httpClient.get(this.API_ENDPOINT + '/mostrarEnlacesLocales', this.httpOptions);
    }
    
     public mostrarPublica() {
        return this.httpClient.get(this.API_ENDPOINT + '/mostrarPublica', this.httpOptions);
    }

    public obtenerMunicipios() {
        return this.httpClient.get(this.API_ENDPOINT + '/obtenerMunicipios', this.httpOptions);
    }

    public reservasFiestaAnual(obj : any) {
        const  params = new  HttpParams()
        .set('doc_id', obj.doc_id)
        .set('nombre_completo', obj.nombre_completo)
        .set('correo_electronico', obj.correo_electronico)
        .set('celular', obj.celular)
        .set('esquema_vacuna', obj.esquema_vacuna)
        .set('tipo_pais_id', obj.tipo_pais_id)
        .set('tipo_dpto_id', obj.tipo_dpto_id)
        .set('tipo_mpio_id', obj.tipo_mpio_id)
        .set('nombre_vacuna', obj.nombre_vacuna)
        .set('numero_dosis', obj.numero_dosis);
        return this.httpClient.get(this.API_ENDPOINT + '/reservasFiestaAnual',{params});
    }

 public almacenPublicidad(crear : any) {
        const  params = new  HttpParams().set('contenido', crear.contenido).set('publicador', crear.publicador).set('sede', crear.sede).set('titulo', crear.titulo);
        return this.httpClient.get(this.API_ENDPOINT + '/almacenPublicidad',{params});
    }

// public registroPersonas(insert : any) {
//         const  params = new  HttpParams().set('contenido', insert.contenido).set('publicador', insert.publicador).set('sede', insert.sede).set('titulo', insert.titulo);
//         return this.httpClient.get(this.API_ENDPOINT + '/registroPersonas',{params});
//     }



}
